import React from 'react';
import { ClientStorageBrowser } from '../../../../components/storage';

interface Props {
  projectId: string;
  selectedPath: string | null;
  onPathChange: (path: string) => void;
  disabled: boolean;
}

// Client Storage source for the New Collection flow. Lists files and folders
// (the shared browser defaults to foldersOnly=false); the export destination
// picker reuses the same browser with foldersOnly enabled.
export function IioQumuloSource({ projectId, selectedPath, onPathChange, disabled }: Props) {
  return (
    <ClientStorageBrowser
      projectId={projectId}
      selectedPath={selectedPath}
      onPathChange={onPathChange}
      disabled={disabled}
    />
  );
}
